import React from 'react';
import {coreColorTokens, tokens} from '@packages/utilities/styled';

import {VisuallyHidden} from '../../VisuallyHidden';
import {PRESENCE_GRADIENT_ID} from '../_consts';

/**
 * This file loads in `SpringProvider`, and is used to define the presence outline gradient.
 * We are collocating it here for context.
 *
 * We are using some hard-coded values right now until we settle on more concrete Design Tokens.
 */
export const PresenceOutlineGradients = () => {
  return (
    <VisuallyHidden>
      <svg height="0" width="0">
        <defs>
          <linearGradient
            id={PRESENCE_GRADIENT_ID.BLUE}
            x1="100%"
            x2="0%"
            y1="100%"
            y2="0%"
          >
            <stop offset="0%" stopColor={tokens.colors.presenceOutlineBlue} />
            <stop offset="25%" stopColor={tokens.colors.presenceOutlineBlue} />
            <stop offset="100%" stopColor="#2394A9" />
          </linearGradient>
          <linearGradient
            id={PRESENCE_GRADIENT_ID.GREEN}
            x1="100%"
            x2="0%"
            y1="0%"
            y2="0%"
          >
            <stop offset="0%" stopColor={tokens.colors.presenceOutlineGreen} />
            <stop offset="25%" stopColor={tokens.colors.presenceOutlineGreen} />
            <stop offset="100%" stopColor="#5CA512" />
          </linearGradient>

          <linearGradient
            id={PRESENCE_GRADIENT_ID.ORANGE}
            x1="100%"
            x2="0%"
            y1="0%"
            y2="0%"
          >
            <stop offset="0%" stopColor={tokens.colors.presenceOutlineOrange} />
            <stop
              offset="25%"
              stopColor={tokens.colors.presenceOutlineOrange}
            />
            <stop offset="100%" stopColor={coreColorTokens.d2.orange[400]} />
          </linearGradient>

          <linearGradient
            id={PRESENCE_GRADIENT_ID.PINK}
            x1="100%"
            x2="0%"
            y1="0%"
            y2="0%"
          >
            <stop offset="0%" stopColor={tokens.colors.presenceOutlinePink} />
            <stop offset="25%" stopColor={tokens.colors.presenceOutlinePink} />
            <stop offset="100%" stopColor={coreColorTokens.d2.pink[400]} />
          </linearGradient>

          <linearGradient
            id={PRESENCE_GRADIENT_ID.RED}
            x1="100%"
            x2="0%"
            y1="0%"
            y2="0%"
          >
            <stop offset="0%" stopColor={tokens.colors.presenceOutlineRed} />
            <stop offset="25%" stopColor={tokens.colors.presenceOutlineRed} />
            <stop offset="100%" stopColor={coreColorTokens.d2.red[400]} />
          </linearGradient>

          <linearGradient
            id={PRESENCE_GRADIENT_ID.YELLOW}
            x1="100%"
            x2="0%"
            y1="0%"
            y2="0%"
          >
            <stop offset="0%" stopColor={tokens.colors.presenceOutlineYellow} />
            <stop
              offset="25%"
              stopColor={tokens.colors.presenceOutlineYellow}
            />
            <stop offset="100%" stopColor="#CCA300" />
          </linearGradient>
        </defs>
      </svg>
    </VisuallyHidden>
  );
};
